import Vue from 'vue';
import mixin from './../../../mixins/mixin';
import accountService from './../../../services/account';
import teamMemberService from "../../../services/team_member";
import Switches from 'vue-switches';
import stripeAccountsService from "../../../services/stripe_accounts";

export default {
    data() {
        return {
            user: {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                description: null,
                password: null,
                active: 1,
                role_id: 2,
                avatar: '',
                notes: null,
                billingInfo: '',
                rental_owner: false,
            },
            change_password: false,
            error: null,
            success: false,
            loading: false,
            rentals: [],
            userRentals: [],
            userRights: {
              calendar: true,
              calendar_planning: true,
              calendar_daily: true,
              calendar_weekly: true,
              calendar_annual: true,
              bookings: true,
              messages: true,
              analytics: true,
              payments: true,
              rentals: true,
              autoactions: true,
              view_prices: true,
              booking_actions: true,
              booking_prices: true,
              support: true,
              analytics_general: true,
              analytics_rentals: true,
              analytics_reviews: true,
              analytics_environment: true,
              analytics_market: true,
            },
            stripeAccount: {},
        };
    },
    components: {
        VLayout: require('layouts/default/default.vue'),
        VPanel: require('components/panel/panel.vue'),
        VLoading : require('components/loading/loading.vue'),
        VInputPassword: require("components/password-input/VueInputPassword.vue"),
        Switches,
    },
    mixins:[mixin],
    async mounted() {
      const vm = this;
      this.loading = true;
      $('#member-avatar').dropify({
        messages: {
          'default': vm.$t("drag_and_drop_file"),
          'replace': 'Drag and drop or click to replace',
          'remove':  'Remove',
          'error':   'Ooops, something wrong happened.'
        }
      });

      if(vm.$route.params.id) {
          await vm.fetch_user(vm.$route.params.id);
      } else {
          await vm.getRentals();
          vm.loading = false;
      }
    },
    methods: {
        delete_user (id) {
            var vm = this;
            swal({
                    title: "Are you sure?",
                    text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>You will not be able to recover this user</div>',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-warning",
                    confirmButtonText: 'Yes, delete it!',
                    closeOnConfirm: false,
                    html: true
                },
                function() {
                    $(".cancel").addClass("disabled");
                    $(".confirm").addClass("disabled");
                    $(".pulseWarning").hide();
                    $("#loading1").show();
                    accountService.deleteSubUsers(vm, id);
                });
        },
        save_user(userData) {
            let vm = this;
            let img = vm.avatar;
            let formData = new FormData();

            vm.loading = true;
            formData.append('image', img);
            formData.append('folder', 'users');

            userData.rights = vm.userRights;
            userData.userRentals = vm.userRentals;


            if (img && img.name) {
                this.loading = true;
                accountService.uploadMemberAvatar(this, formData, userData);
            } else {
              teamMemberService.storeTeamMember(userData, this);
            }
        },
        edit_user(user) {
          user.change_password = this.change_password ? 1 : 0;
          this.loading = true;

          const img = this.avatar;

          if (img && img.name) {
            // const image = { image: img };
            const formData = new FormData();
            formData.append('image', img);
            formData.append('folder', 'users');
            accountService.uploadMemberAvatar(this, formData, user, true);
          } else {
            this.update_user(user);
          }
        },
        onAvatarChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.avatar = files[0];
        },
        async fetch_user(id){
            await teamMemberService.fetch(this, id);
        },
        update_user(user) {
            user.userRentals = this.userRentals;
            user.rights = this.userRights;
            if (user.avatar) {
              user.avatar = user.avatar.substring(user.avatar.lastIndexOf('/') + 1, user.avatar.length);
            }
            teamMemberService.update(user, this);
        },
        async getRentals() {
            await teamMemberService.getRentals(this);
        },
        changeAccessPropertiesStatus(rental_id, access) {
            let vm = this;
            if(access) {
                access = 0;
            } else {
                access = 1;
            }


            let found = vm.userRentals.some(function (item) {
               if(item.rental_id == rental_id) {
                   item.access = access;
                   return true;
               } else {
                   return false;
               }
            });
        },
        checkAnalyticsChanged(val) {
          if (val) {
            this.userRights.analytics_general = true;
            // this.userRights.analytics_rentals = true;
            this.userRights.analytics_reviews = true;
            this.userRights.analytics_environment = true;
            this.userRights.analytics_market = true;
          } else {
            this.userRights.analytics_general = false;
            // this.userRights.analytics_rentals = false;
            this.userRights.analytics_reviews = false;
            this.userRights.analytics_environment = false;
            this.userRights.analytics_market = false;
          }
      },
        checkCalendarChanged(val) {
          if (val) {
            this.userRights.calendar_planning = true;
            this.userRights.calendar_daily = true;
            this.userRights.calendar_weekly = true;
            this.userRights.calendar_annual = true;
          } else {
            this.userRights.calendar_planning = false;
            this.userRights.calendar_daily = false;
            this.userRights.calendar_weekly = false;
            this.userRights.calendar_annual = false;
          }
      },
        confirmDeleteStripeAccount(id, index) {
          $('.cancel').removeClass('disabled');
          swal({
              title: '',
              text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75">
                       <circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t("account.settings.stripe_account_delete")}</div>`,
              type: 'warning',
              showCancelButton: true,
              confirmButtonClass: 'btn-warning',
              confirmButtonText: this.$t('rentals.detail.modals.yes_delete_it'),
              closeOnConfirm: false,
              html: true
            },
            () => {
              $('.cancel').addClass('disabled');
              $('.confirm').addClass('disabled');
              $(".pulseWarning").hide();
              $("#loading1").show();
              let data = {
                id: id,
                memberId: this.user.id
              }
              stripeAccountsService.deleteStripeAccount(this, data, index);
            });
        },
        getUserBillingInfo() {
          const apiUrl = process.env.API_URL;
          this.user.billingInfo = this.user.stripe_id ? `${this.user.stripe_id}\n\n` : '';
          this.user.billingInfo += `${window.location.protocol}${apiUrl}/#/connect/${this.user.permalink}`;
        },
        deleteMemberAvatar(user) {
          this.loading = true;
          accountService.deleteAvatar(this, user);
        },
    }
};



// WEBPACK FOOTER //
// ./src/app/pages/account/users/users.js